import React, { useEffect } from 'react'
import { useAdmin } from '../../context/AdminContext'
import { Link } from "react-router-dom"
import { Oval } from 'react-loader-spinner'
import "./VistaConsultoraNormas.scss"
import IllustrationAccess from "../../assets/img/access.png"

function VistaConsultoraNormas(props) {

    const { loadingEmpresas, errorEmpresa, empresas, fetchEmpresasById } = useAdmin()

    useEffect(() => {
        fetchEmpresasById(props.user, props.user.idConsultora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {loadingEmpresas ? (
                <div className='loading__listaEmpresasNormas d-flex flex-column align-items-center justify-content-center'>
                    <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#0d6efd"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='fw-medium'>Loading...</p>
                </div>
            ) : (
                <>
                    {errorEmpresa ? (
                        <div className='listaEmpresas__main--error d-flex flex-column align-items-center justify-content-center rounded-3'>
                            <img className='mb-4' src={IllustrationAccess} alt="" />
                            <h2 className='text-danger fw-semibold mb-2'>Oops!</h2>
                            <p className='text-center'>{errorEmpresa}</p>
                            <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
                        </div>
                    ) : (
                        <>
                            {empresas.length === 0 ? (
                                <div className='listaEmpresas__main--empty d-flex flex-column align-items-center justify-content-center rounded-3'>
                                    <img className='mb-4' src={IllustrationAccess} alt="" />
                                    <h3 className='text-blue-500 fw-semibold mb-1 text-center'>No tienes empresas asignadas.</h3>
                                    <p className='text-center'>Contactar al equipo de soporte para el manejo de empresas.</p>
                                    <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
                                </div>
                            ) : (
                                <div className='listaEmpresas__main scroll--y'>
                                    <div className='table__custom__emp'>
                                        <div className='table__custom__emp__header'>
                                            <div className='table__custom__emp__cell table__custom__emp__cell--title fw-bold cell__id text-center'></div>
                                            <div className='table__custom__emp__cell table__custom__emp__cell--title fw-bold cell__name'>Nombre</div>
                                        </div>
                                        <div className='table__custom__emp__body'>
                                            {empresas.map((e, i) => {
                                                return <Link key={i} className='table__custom__emp__row text-decoration-none text-dark' to={`/normas/empresa/${e.id_empresa}`}>
                                                    <div className='table__custom__emp__cell cell__id fw-bold text-center'>{e.id_empresa}</div>
                                                    <div className='table__custom__emp__cell cell__name'>{e.nombre}</div>
                                                </Link>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    )
}

export default VistaConsultoraNormas